"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.targetValueSubtitle = exports.targetRowSubtitle = void 0;
var threshold_1 = require("../../features/threshold");
var numberFormatter_1 = require("../numberFormatter");
var localization_1 = require("../../localization");
var targetRowSubtitle = function (definition) {
    return function (currentPoint) {
        var comparisonMeasureAccessor = (0, threshold_1.buildFirstThresholdMeasureAccessor)(definition);
        var targetValue = comparisonMeasureAccessor && comparisonMeasureAccessor(currentPoint);
        var formattedTargetValue = (0, numberFormatter_1.formatValueAsMetricNumber)(targetValue);
        return localization_1.Messages.metricsTargetRowSubtitle({ targetValue: formattedTargetValue });
    };
};
exports.targetRowSubtitle = targetRowSubtitle;
var targetValueSubtitle = function (value, formatString) {
    var formattedTargetValue = (0, numberFormatter_1.formatValueAsMetricNumber)(value, formatString);
    return localization_1.Messages.metricsTargetRowSubtitle({ targetValue: formattedTargetValue });
};
exports.targetValueSubtitle = targetValueSubtitle;
//# sourceMappingURL=targetSubtitle.js.map